export const mapLeadDataToFormValue = (field, lead, contact) => {
  if (!field || !lead) return "";
  
  const fieldId = String(field.id);
  const fieldKey = field.key || fieldId;

  // 1. System Fields Mapping
  if (fieldKey === "system_name") {
    return contact?.name || lead.contact?.name || "";
  }
  if (fieldKey === "system_email") {
    return contact?.email || lead.contact?.email || "";
  }
  if (fieldKey === "system_phone") {
    return contact?.phone || lead.contact?.phone || "";
  }

  // 2. Common Fields Mapping (Company)
  // Check both key 'company' and label 'Company' for legacy/fallback
  if (fieldKey === "company" || field.label?.toLowerCase() === "company") {
    return contact?.company || lead.contact?.company || "";
  }

  // 3. Status Mapping
  if (fieldKey === "status") {
    if (typeof lead.status === "object" && lead.status !== null) {
      return lead.status._id || lead.status.id || "";
    }
    return lead.status || "";
  }

  // 4. Source Mapping
  if (fieldKey === "source") {
    let currentSource = lead.source || "";
    
    // Normalize source strings that come from webhook like "Facebook Lead Ads"
    if (currentSource) {
      const lowerSrc = currentSource.toLowerCase();
      if (lowerSrc.includes("facebook")) currentSource = "Facebook";
      else if (lowerSrc.includes("whatsapp")) currentSource = "WhatsApp";
      else if (lowerSrc.includes("instagram")) currentSource = "Instagram";
    }

    if (!currentSource || currentSource === "Manual" || currentSource === "Facebook") {
      const platform = lead.customFields?.platform?.toLowerCase() || lead.platform?.toLowerCase();
      if (platform === "ig" || platform === "instagram") {
        currentSource = "Instagram";
      } else if (lead.whatsappContactId || platform === "whatsapp") {
        currentSource = "WhatsApp";
      } else if (lead.facebookLeadId || platform === "facebook") {
        currentSource = "Facebook";
      } else if (!currentSource) {
        currentSource = "Manual";
      }
    }
    
    // If we have options, ensure it maps to Other if missing, but we don't have options here.
    // The CustomSelect fallback will show the literal value if it doesn't match an option.
    return currentSource;
  }

  // 4.5 Created Date Mapping (fb_created_time)
  if (fieldKey === "fb_created_time") {
    let val = lead.fb_created_time || (lead.customFields instanceof Map ? lead.customFields.get("fb_created_time") : lead.customFields?.fb_created_time);
    
    // Fallback to system createdAt or leadDetails.created
    if (!val) {
      val = lead.details?.leadDetails?.created || lead.createdAt;
    }
    return val || "";
  }

  // 5. Custom Fields Mapping
  // Try top-level flat structure first (e.g., from AddLeadModal or legacy)
  if (lead[fieldKey] !== undefined && lead[fieldKey] !== null) {
    return lead[fieldKey];
  }

  // Try nested details.contact (modern structure)
  if (lead.details?.contact) {
    const val = lead.details.contact[fieldKey] ?? lead.details.contact[fieldId];
    if (val !== undefined && val !== null) return String(val);
  }

  // Fallback to nested customFields
  if (lead.customFields) {
    if (lead.customFields instanceof Map) {
      const val =
        lead.customFields.get(fieldKey) ?? lead.customFields.get(fieldId);
      if (val !== undefined && val !== null) return String(val);
    } else {
      const val = lead.customFields[fieldKey] ?? lead.customFields[fieldId];
      if (val !== undefined && val !== null) return String(val);
    }

    // Leads synced from Facebook keep the answer under the Facebook question key
    if (field.facebookField) {
      const fbVal =
        lead.customFields instanceof Map
          ? lead.customFields.get(field.facebookField)
          : lead.customFields[field.facebookField];
      if (fbVal !== undefined && fbVal !== null) return String(fbVal);
    }
  }

  return "";
};
